































































import Vue from 'vue'
import { TransferDirectoryServiceProxy } from '@/service-proxies/app-v2/dnc.service-proxies'
import { AuthorityDomainServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

import * as _ from 'lodash'

const transferDirectoryServiceProxy = new TransferDirectoryServiceProxy()
const authorityDomainServiceProxy = new AuthorityDomainServiceProxy()
export default Vue.extend({
  name: 'AddOrEditDirectory',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add'
    },
    groupData: {
      // 分组的数据
      type: Object,
      required: true
    },
    detail: {
      type: Object
    }
  },
  data() {
    return {
      picture: '',
      currentDeptId: undefined,
      form: this.$form.createForm(this),
      loading: false,
      replaceFields: {
        key: 'id'
      },
      deptList: [], // 职权域列表
      value: '',
      hasDept: false
    }
  },
  computed: {
    modalTitle() {
      return this.type === 'add' ? this.$t('add_directory') : this.$t('edit_directory')
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.picture = ''
          this.value = ''
          this.deptList = []
          this.getDeptList()
          if (this.type === 'add') {
            this.picture = ''
            this.form = this.$form.createForm(this)
          } else {
            // console.log('detail:', this.detail)
            this.picture = this.detail.picture
            this.form = this.$form.createForm(this, {
              mapPropsToFields: () => {
                let fields = {
                  name: this.$form.createFormField({
                    value: this.detail.name
                  }),
                  deptId: this.$form.createFormField({
                    value: this.detail.deptId
                  })
                }
                return fields
              }
            })
          }
        }
      },
      immediate: true
    },
    deptList: {
      handler(val) {
        // console.log('this.detail.deptId', this.detail.deptId)
        if (this.type === 'add') {
          if (val.length) {
            this.form.setFieldsValue({ deptId: val[0].value })
          }
        } else {
          authorityDomainServiceProxy.findNameValueById(this.detail.deptId).then((nameValue) => {
            this.currentDeptId = this.detail.deptId
            this.form.setFieldsValue({ deptId: nameValue.value })
          })
        }
      },
      deep: true
    },
    groupData: {
      handler(val) {
        console.log('groupData:', val)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 获取职权域列表
    getDeptList() {
      authorityDomainServiceProxy.getEnableTreeList().then((res: any) => {
        if (res.data && res.data.length) {
          res.data.forEach((item: any) => {
            this.deptList.push(this.createNode(item))
          })
        }
      })
    },
    // 处理树结构
    createNode(item: any) {
      const children = item.children

      const node = {
        key: item.id,
        value: item.id,
        title: item.title,
        children: children
      }

      if (children != null) {
        const length = children.length
        if (length > 0) {
          const childrenList = []
          for (let i = 0; i < length; i++) {
            childrenList[i] = this.createNode(children[i])
          }

          node.children = childrenList
        }
      }
      return node
    },
    selectdept(value: any) {
      this.value = value
    },
    // 遍历树结构，判断当前职权域id是否被禁用，若被禁用，则id取this.detail.deptId
    mapTree(id: string, item: any) {
      const children = item.children
      if (item.key === id) {
        this.hasDept = true
      } else {
        if (children != null && children.length) {
          for (let i = 0; i < children.length; i++) {
            this.mapTree(id, children[i])
          }
        }
      }
    },
    handleOk() {
      this.loading = true
      this.form.validateFieldsAndScroll((err: any, values: any) => {
        if (err) {
          this.loading = false
          return
        }

        this.hasDept = false
        this.deptList.forEach((item: any) => {
          this.mapTree(values.deptId, item)
        })
        // 若当前选中职权域被禁用，则获取初始deptId
        if (!this.hasDept) {
          values.deptId = this.detail.deptId
        }
        let params = {
          ...values,
          picture: this.picture,
          groupId: this.groupData.id,
          groupAllPath: this.groupData.allPath
        }
        if (this.type === 'edit') {
          Object.assign(params, {
            id: this.detail.id,
            groupId: this.detail.groupId,
            groupAllPath: this.detail.groupAllPath
          })
        }
        // 先判断节点在不在数据源中,不在数据源节点中，在使用原来的替换
        /*const idList = _.flatMapDeep(this.deptList,c=>c.children);
        const deptId = params.deptId;
        const inDept = this.deptList.some(c=>c.key == deptId) || idList.some(c=>c.key == deptId);
        if(!inDept && this.currentDeptId){
          params.deptId = this.currentDeptId;
        }*/
        transferDirectoryServiceProxy
          .save(params)
          .then((res: any) => {
            if (res) {
              this.$emit('close', true)
            }
          })
          .finally(() => {
            this.loading = false
            this.deptId = undefined
          })
      })
    },
    handleCancel() {
      this.$emit('close')
    }
  }
})
